'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('slate');

var _TablePosition = require('./TablePosition');

var _TablePosition2 = _interopRequireDefault(_TablePosition);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * The position of the selection start block, in the current table
 */


function getPosition(opts, // The current value
value) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : value.startKey;
  return _TablePosition2.default.create(opts, value.document, key);
}

exports.default = getPosition;